@if ({
  formatTypeOptions: formatTypeOptions$ | async,
  exportTypeOptions: exportTypeOptions$ | async,
  isLoading: isLoading$ | async,
  }; as content) {
  @if (!content.isLoading) {
    <div class="simple-card m-t-20">
      <div class="col-12">
        <div class="row">
          <p class="m-b-20">
            Use the form below to request the latest copy of your price media file. You will be notified via e-mail when it is available,
            and a copy will be downloaded on the Price Media Request History tab.
          </p>
          <p></p>
        </div>
        <div class="row">
          <p class="m-b-20 h5">Current Account</p>
        </div>
        <div class="row">
          <p class="m-b-20">{{ displayAccount }}</p>
        </div>
      </div>
      <form [formGroup]="form" (submit)="loadPriceMedia()">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group w custom-date-picker">
              <div class="d-flex v-center m-b-4">
                <label for="effectiveDate" class="m-0">Effective Date</label>
              </div>
              <p-datepicker
                formControlName="priceEffectiveDate"
                id="effectiveDate"
                dateFormat="mm/dd/yy"
                showIcon="true"
                inputStyleClass="form-control"
                placeholder="..."
              ></p-datepicker>
              <cx-form-errors [control]="form.get('priceEffectiveDate')"></cx-form-errors>
            </div>
          </div>
          <div class="col-md-4 m-t-40">
            <div class="form-check m-0">
              <label>
                <input formControlName="specialPricing" type="checkbox" checked />
                <span class="form-check-label">Special Pricing</span>
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 m-t-20">
            <span>Format Type</span>
            <select class="form-control" formControlName="formatType">
              <option value="" disabled selected>Select an option</option>
              @for (item of content.formatTypeOptions; track item) {
                <option [value]="item.code">
                  {{ item.label }}
                </option>
              }
            </select>
            <cx-form-errors [control]="form.get('formatType')"></cx-form-errors>
          </div>
          <div class="col-md-4 m-t-20">
            <span>Export Type</span>
            <select class="form-control" formControlName="exportTypes">
              <option value="" disabled selected>Select an option</option>
              @for (item of content.exportTypeOptions; track item) {
                <option [value]="item.code">
                  {{ item.label }}
                </option>
              }
            </select>
            <cx-form-errors [control]="form.get('exportTypes')"></cx-form-errors>
          </div>
        </div>
        <div class="row w-100 form-button-container">
          <div class="col-12 col-md-2 m-t-20 d-flex h-end">
            <button type="submit" class="btn btn-primary btn-sm w-100">SUBMIT REQUEST</button>
          </div>
        </div>
      </form>
    </div>
  } @else {
    <local-loader class="m-tb-20"></local-loader>
  }
}
